<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useCriarParecerStore } from '@/store/criarParecerStore';
import { useLoadingStore } from '@/store/loadingStore';

const store = useCriarParecerStore();
const loadingStore = useLoadingStore();
const { loading } = storeToRefs(loadingStore);
const { anoSelecionado, trimestreSelecionado, criteriosDaRubrica, disciplinasDaArea, objetivosArea, desempenhoPorComponente, parecerMinimo, competencias, sugestoesMelhoria, desempenhoPorCompetencia, parecerParte1, parecerParte2, parecerParte3, controleDesempenhoPorCriterio } = storeToRefs(store);


import ProgressBar from 'primevue/progressbar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Stepper from 'primevue/stepper';
import StepperPanel from 'primevue/stepperpanel';
import FloatLabel from 'primevue/floatlabel';
import Slider from 'primevue/slider';
import { trimestres, anos, notacoesPadrao } from '@/store/dadosPadrao';

const router = useRouter();

function goBack() {
    router.push('/professor')
}

function definirNomeDisciplina(id) {
    let disciplina = disciplinasDaArea.value.filter(item => item.id === id);
    if (disciplina.length > 0) {
        return disciplina[0].nome;
    } else {
        return id;
    }
}

onMounted(()=>{
    store.carregarDados();
});

</script>
<template>
    <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <div class="h-screen  bg-white">
        <div class=" h-full  ">
            <div class="header border-bottom-1 border-200 z-3">
                <div class="text-color text-xl flex align-items-center">
                    <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter"
                        severity="secondary" />
                    <span class="ml-2">Elaborar Parecer</span>

                </div>
            </div>

            <div class="pt-8 p-5">
                <div class="flex gap-3 p-3">
                    <Dropdown v-model="trimestreSelecionado" :options="trimestres" optionLabel="trimestre"
                        optionValue="id" placeholder="Selecione o trimestre" class="w-full"
                        @change="store.carregarDados" />
                    <Dropdown v-model="anoSelecionado" :options="anos" optionLabel="ano" optionValue="id"
                        placeholder="Selecione o ano" class="w-full" @change="store.carregarDados" />
                </div>
                <div class="grid">
                    <div class="col-12 lg:col-8">
                        <Stepper orientation="vertical">
                            <StepperPanel header="Definir objetivo da área">
                                <template #content="{ nextCallback }">
                                    <div class="flex flex-column p-4">
                                        <FloatLabel>
                                            <Textarea rows="1" autoResize v-model="parecerMinimo.texto"
                                                id="parecerminimo" class="w-full" />
                                            <label id="parecerminimo" for="parecerminimo">O que o estudante
                                                minimamente
                                                atingiu</label>
                                        </FloatLabel>
                                        <div class="mt-4 font-medium">Objetivo da área</div>
                                        <div v-for="(item, index) in objetivosArea.conteudo" :key="index">
                                            <div class="mt-4">
                                                <FloatLabel>
                                                    <Textarea rows="1" autoResize v-model="item.texto"
                                                        @input="item.status = 'modificado'" :id="item.disciplina"
                                                        class="w-full" />
                                                    <label :id="index" :for="index">{{
                                                        item.disciplinaNome
                                                        }}</label>
                                                </FloatLabel>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </StepperPanel>
                            <StepperPanel header="Definir competência dos componentes">
                                <template #content="{ prevCallback, nextCallback }">
                                    <div class="flex flex-column gap-3 mb-3">
                                        <div class="flex flex-column gap-2" v-for="(item, index) in competencias"
                                            :key="index">
                                            <div class="flex flex-row gap-2">
                                                <Dropdown class="w-5" :options="disciplinasDaArea"
                                                    v-model="item.disciplina" optionLabel="nome" optionValue="id"
                                                    @change="store.salvarCompetencia(index)" />

                                                <Button severity="danger" icon="pi pi-trash"
                                                    @click="store.excluirCompetencia(index)" />
                                            </div>

                                            <Textarea rows="2" autoResize class="w-full" v-model="item.competencia"
                                                placeholder="Competência" @input="store.salvarCompetencia(index)" />
                                        </div>


                                    </div>
                                    <Button label="Adicionar Competência" @click="store.adicionarCampoCompetencia"
                                        class="m-1" />
                                </template>
                            </StepperPanel>

                            <StepperPanel header="Definir sugestões de melhoria">
                                <template #content="{ prevCallback, nextCallback }">
                                    <div class="flex flex-column gap-3 mb-3">
                                        <div class="flex flex-column gap-2" v-for="(item, index) in sugestoesMelhoria"
                                            :key="index">
                                            <div class="flex flex-row gap-2">
                                                <Dropdown class="w-5" :options="criteriosDaRubrica"
                                                    v-model="item.criterio" optionLabel="criterio" optionValue="id"
                                                    @change="store.salvarSugestaoMelhoria(index)" />
                                                <Button severity="danger" icon="pi pi-trash"
                                                    @click="store.excluirSugestaoMelhoria(index)" />
                                            </div>
                                            <Textarea rows="4" autoResize class="w-full" v-model="item.sugestao"
                                                placeholder="Sugestão" @input="store.salvarSugestaoMelhoria(index)" />

                                        </div>
                                    </div>
                                    <Button label="Adicionar Sugestão" class="m-1"
                                        @click="store.adicionarCampoSugestaoMelhoria" />
                                </template>
                            </StepperPanel>
                            <StepperPanel header="Testar parecer">
                                <template #content="{ prevCallback }">
                                    <div class="flex flex-column " style="height: 600px;">
                                        <div class="flex gap-5 flex-column">
                                            <div>
                                                <div class="text-sm font-semibold">Escolher desempenho por componente
                                                </div>
                                                <div class="flex flex-row flex-wrap gap-2">
                                                    <div v-for="(item, index) in desempenhoPorComponente" :key="index">
                                                        <div class="mb-1 mt-2">{{ definirNomeDisciplina(item.disciplina)
                                                            }}</div>
                                                        <Dropdown v-model="item.notacao" :options="notacoesPadrao"
                                                            optionLabel="nome" optionValue="valor"
                                                            placeholder="Selecione uma notacao" class="w-7rem" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-column gap-3">
                                                <div class="text-sm font-semibold">Definir Desempenho por Competência
                                                </div>
                                                <div v-for="(item, index) in desempenhoPorCompetencia" :key="index">
                                                    <div class="text-xs mb-1">{{ item.competencia }}</div>
                                                    <Slider v-model="item.desempenho" />
                                                </div>
                                            </div>

                                            <div>
                                                <div class="text-sm font-semibold mb-2">Definir nível de desempenho nos
                                                    critérios</div>
                                                <div class="flex flex-column gap-5">
                                                    <div v-for="controle in controleDesempenhoPorCriterio"
                                                        :key="controle.id">
                                                        <div class="text-sm">{{ controle.criterio }}</div>
                                                        <Slider class="w-full" v-model="controle.desempenho" />
                                                    </div>



                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </StepperPanel>
                        </Stepper>
                    </div>
                    <div class="col-12 lg:col-4 pt-4  ">
                        <div class=" mt-3 flex flex-column gap-3 lg:sticky lg:top-0">
                            <div>{{ parecerParte1 }}</div>
                            <div class="flex flex-column gap-3" v-html="parecerParte2"></div>
                            <div class="flex flex-column gap-3" v-html="parecerParte3"></div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
